module.exports = __webpack_public_path__ + "img/IMG_3626.189ecb5d.jpg";